module.exports = __webpack_public_path__ + "static/img/9.12f5a5c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/sp/9.png
// module id = Vw/W
// module chunks = 0